import React, { Component } from 'react'
import Contractors from '../../globals/images/icon-contractors.svg'
import Municipal from '../../globals/images/icon-municipal.svg'
import DGContractors from '../../globals/images/icon-solar.svg'
import Tile from '../shared/tile/Tile'
import PropTypes from 'prop-types'
export default class LogInFooter extends Component {
  
  render() {    
    const { contractorsUrl, municipalUrl, dgContractorsUrl } = this.props
    return (
        <>      
            <h2 className="o-heading-gamma o-heading-underline--sm u-text-center u-text-uppercase pb-5 mb-8">Partners Sign in</h2>
            <div className="os-flex-grid os-flex--stack-mobile">
                <Tile url= { contractorsUrl } img= { Contractors } textContent= { 'Builders & Contractors' } />
                <Tile url= { municipalUrl } img= { Municipal } textContent= { 'Municipal Inspectors' } />
                <Tile url= { dgContractorsUrl } img= { DGContractors } textContent= { 'DG Contractors' }/> 
            </div>
        </>
    )
  }
}

LogInFooter.propTypes = {
    contractorsUrl: PropTypes.string.isRequired,
    municipalUrl: PropTypes.string.isRequired,
    dgContractorsUrl: PropTypes.string.isRequired
}